import nodeType from './nodeTypeFilter';

export default {
    install(Vue) {
        Vue.filter('nodeType', nodeType);
    }
}
